import { Backend } from '../../../api/Backend';
import { IScheduleV5 } from '../../../api/models/AndromeTV.types';
import { ChannelModel } from '../../../api/EpgApi.types';
import { Recording } from '../../../api/user/RecordingApi.types';
import { EpgUtil } from '../../utility/EpgUtil';
import { BlackoutUtil } from '../../utility/BlackoutUtil';
import { StreamType } from '../../../api/models/Shared.types';
import { ErrorTranslationKeys } from '../../../api/models/TranslationKeys';

export function getEpgWatchability(
  backend: Backend,
  schedule?: IScheduleV5,
  channel?: ChannelModel,
  recording?: Recording,
  checkOnlyRecording = false
): { showWatchButton: boolean; blackoutLabel?: string } {
  let showWatchButton = false;
  let blackoutLabel = undefined;

  if (!schedule || !channel) {
    return {
      showWatchButton: false,
      blackoutLabel: undefined,
    };
  }

  if (!backend.isAuthorized()) {
    //TODO unauthenticated case
    return {
      showWatchButton: false,
      blackoutLabel: undefined,
    };
  }

  if (hasRecordingRights(schedule, channel, recording, backend)) {
    showWatchButton = true;
    if (EpgUtil.scheduleHasBlackout(schedule?.blackouts, BlackoutUtil.create(StreamType.NPVR))) {
      blackoutLabel = backend.translations.forKey(ErrorTranslationKeys.error_blackout_npvr_ott);
    }
  }

  if (checkOnlyRecording) {
    return {
      showWatchButton,
      blackoutLabel,
    };
  }

  if (hasLinearRights(schedule, channel)) {
    showWatchButton = true;
    if (EpgUtil.scheduleHasBlackout(schedule.blackouts, BlackoutUtil.create(StreamType.LINEAR))) {
      blackoutLabel = backend.translations.forKey(ErrorTranslationKeys.error_blackout_linear_ott);
    }
  }

  if (hasReplayRights(schedule, channel)) {
    showWatchButton = true;
    if (EpgUtil.scheduleHasBlackout(schedule.blackouts, BlackoutUtil.create(StreamType.REPLAY))) {
      blackoutLabel = backend.translations.forKey(ErrorTranslationKeys.error_blackout_replay_ott);
    }
  }

  if (!showWatchButton && blackoutLabel === '') {
    blackoutLabel = backend.translations.forKey(ErrorTranslationKeys.error_no_rights_detail_description);
  }

  return {
    showWatchButton,
    blackoutLabel,
  };
}

export function hasRecordingRights(
  schedule: IScheduleV5,
  channel: ChannelModel,
  recording: Recording | undefined,
  backend: Backend
) {
  return recording && recording.canWatchNpvrWithRights(channel) && recording.device === backend.sessionInfo?.npvr?.id;
}

export function hasLinearRights(schedule: IScheduleV5 | undefined, channel: ChannelModel) {
  return channel.customerHasRight(StreamType.LINEAR) && EpgUtil.scheduleIsLive(schedule);
}

export function hasReplayRights(schedule: IScheduleV5 | undefined, channel: ChannelModel) {
  if (!schedule) return false;
  return EpgUtil.scheduleIsReplay(schedule, channel) && channel.customerHasRight(StreamType.REPLAY);
}
